import {expectOneOf, HttpClient$, POST} from '@raison/network-facade';
import {any} from 'io-ts';
import {atom} from 'jotai';

export type PaymentMethod = {
    type: string;
    id: number;
    currency: string;
};

export const paymentMethodPost = atom(get => (data: PaymentMethod) => {
    const http = get(HttpClient$);
    return http('/v1/info/payment_method', POST(data)).then(
        expectOneOf({
            200: any,
            401: null,
        })
    );
});
